var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_vm._t("trigger",null,{"expand":_vm.expand,"collapse":_vm.collapse,"toggle":_vm.toggle,"expanded":_vm.expanded}),_c('FlotoExpand',[(_vm.expanded)?_c('div',[_vm._t("default",null,{"toggle":_vm.toggle,"expand":_vm.expand,"collapse":_vm.collapse,"expanded":_vm.expanded})],2):_vm._e()])],2)
}
var staticRenderFns = []

export { render, staticRenderFns }